import {TabCommunicationInterface, TabCommunicationEvent} from './TabCommunication'

export class TabCommunicationLocalStorage implements TabCommunicationInterface {
    private readonly eventCallbacks: Map<TabCommunicationEvent, () => void>
    private readonly STORAGE_KEY_PREFIX = 'tab_communication_event_'
    constructor() {
        this.eventCallbacks = new Map()

        window.addEventListener('storage', (event) => {
            if(!event.key) return
            if(!event.key.startsWith(this.STORAGE_KEY_PREFIX)) return

            const eventName = event.key.slice(this.STORAGE_KEY_PREFIX.length)
            const tabEvent = TabCommunicationEvent[eventName as keyof typeof TabCommunicationEvent]
            const callback = this.eventCallbacks.get(tabEvent)

            callback?.()
        })
    }

    sendEvent(event: TabCommunicationEvent): void {
        const eventKey = this.STORAGE_KEY_PREFIX + TabCommunicationEvent[event]
        localStorage.setItem(eventKey, Date.now().toString())
        localStorage.removeItem(eventKey)
    }

    onEvent(event: TabCommunicationEvent, callback: () => void): void {
        this.eventCallbacks.set(event, callback)
    }
}
